// extracted by mini-css-extract-plugin
module.exports = {"contacts":"contacts--2Pw3r","checkList":"checkList--3uEGg"};